import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DemoComponent } from './components/demo/demo.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxImgZoomModule } from 'ngx-img-zoom';


import { MainComponent } from './components/main/main.component';



import { AppRoutingModule } from './app-routing.module';
import { ShopModule } from './components/shop/shop.module';
import { SharedModule } from './components/shared/shared.module';
import { AuthModule } from './components/auth/auth.module';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { MessagingService } from './components/shared/services/messaging.service';
import { AsyncPipe } from '@angular/common';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { GoogleLoginProvider, FacebookLoginProvider, AuthService, AuthServiceConfig } from 'angularx-social-login';
import { SharedMethods } from './components/shared/services/sharedMethods-service';
import { MatomoModule } from '@codeculture/ngx-matomo';

export function socialConfigs() {
  const config = new AuthServiceConfig(
    [
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('955058621598957')
      },
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('922194426470-euasrdcenpr86mbfs2em0gf99858hqmp.apps.googleusercontent.com')
      }
    ]
  );
  return config;
}

//  recuperation des settings au demarrage
export function settingProviderFactory(provider:  SharedMethods) {
  return () =>  new Promise<any>((resolve) => {
                                    provider.getSettings().subscribe( setting => {
                                      provider.cacheSettings = setting;
                                      resolve(true);
                                    }, (err) => {

                                    });
                                });

}


@NgModule({
  declarations: [
    AppComponent,
    DemoComponent,
    MainComponent,
  ],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    SharedModule,
    ShopModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgxImgZoomModule,
    AuthModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    DeviceDetectorModule.forRoot(),
    MatomoModule
  ],
  providers: [
    MessagingService,
    AsyncPipe,
    AuthService,
    SharedMethods,
    {
      provide: AuthServiceConfig,
      useFactory: socialConfigs
    },
    /* {
      provide: APP_INITIALIZER,
      useFactory: settingProviderFactory,
      deps: [SharedMethods],
      multi: true
    }, */

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
